import { z } from "zod/v4";
import { fetchApi } from "./internal";

export const demoClubReseedResultSchema = z.object({
	club_id: z.string(),
	email: z.string(),
	tier: z.string(),
	members: z.number(),
	invoices: z.number(),
	events: z.number(),
	training_seasons: z.number(),
	training_groups: z.number(),
	training_registrations: z.number(),
	tournaments: z.number(),
	tournament_teams: z.number(),
});

export type DemoClubReseedResult = z.infer<typeof demoClubReseedResultSchema>;

export const demoClubs = {
	// Purges + recreates the demo club from scraped_athletes. Staging-only;
	// the identity service rejects this on other environments.
	reseed: () =>
		fetchApi("/admin/demo-clubs", demoClubReseedResultSchema, {
			method: "POST",
		}),
};
